/**
 * Segment de route des garanties orphelines.
 *
 * Un identifiant de branche est un uuid : ce mot réservé ne peut donc pas entrer en
 * collision avec `/branches/:brancheId`.
 */
export const UNASSIGNED_ROUTE_SEGMENT = 'sans-branche';
